import $ from "jquery";
import jsrender from "jsrender";
window.$ = window.jQuery = jsrender($);

export default window.$;
